"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchStartCommand = void 0;
const Command_1 = require("../Command");
const BranchRequirementType_1 = require("../lib/BranchRequirementType");
const CommandType_1 = require("../lib/CommandType");
/**
 * Having this command in a song notation will mark the song's difficulty on
 * song selection as having diverge notes and the song will appear to start on
 * the Normal branch.
 *
 * **Example:**
 *
 * ```
 * #BRANCHSTART p,75,85
 * ```
 */
class BranchStartCommand extends Command_1.Command {
    constructor(requirementType, advancedRequirement, masterRequirement) {
        super(CommandType_1.CommandType.BranchStart);
        this.requirementType = requirementType;
        this.advancedRequirement = advancedRequirement;
        this.masterRequirement = masterRequirement;
    }
    static parse(args, strict) {
        if (args.length === 0) {
            return undefined;
        }
        const components = args[0].split(',');
        if (components.length !== 3) {
            return undefined;
        }
        const requirementType = BranchRequirementType_1.BranchRequirementType.fromRaw(components[0], strict);
        if (!requirementType) {
            return undefined;
        }
        const advancedRequirement = parseInt(components[1], 10);
        if (isNaN(advancedRequirement)) {
            return undefined;
        }
        const masterRequirement = parseInt(components[2], 10);
        if (isNaN(masterRequirement)) {
            return undefined;
        }
        return new BranchStartCommand(requirementType, advancedRequirement, masterRequirement);
    }
    toString() {
        return `${super.toString()} ${this.requirementType},${this.advancedRequirement},${this.masterRequirement}`;
    }
}
exports.BranchStartCommand = BranchStartCommand;
